import { useState } from 'react';
import { IconX } from '@tabler/icons-react';
import { deleteSubscription } from '../api';
import { formatExpiryDate } from '../utils/formatDate';
import { formatSubscriptionTitle } from '../utils/subscription';
import { useModalA11y } from '../utils/useModalA11y';
import ErrorMessage from './ui/ErrorMessage';
import { track } from '../utils/analytics';
import './DeleteSubscriptionModal.scss';

export default function DeleteSubscriptionModal({ subscription, onClose, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const dialogRef = useModalA11y(true, onClose);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        setError('');
        try {
            await deleteSubscription(subscription.id);
            track('subscription_deleted', { subscription_id: subscription.id });
            onSuccess(subscription);
            onClose();
        } catch (err) {
            setError(err.message || 'Не удалось удалить подписку');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="confirm-modal-overlay" onClick={handleOverlayClick}>
            <div
                ref={dialogRef}
                className="confirm-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="delete-sub-title"
            >
                <div className="confirm-modal__header">
                    <h3 id="delete-sub-title">Удалить подписку?</h3>
                    <button
                        type="button"
                        className="confirm-modal__close"
                        onClick={onClose}
                        aria-label="Закрыть"
                    >
                        <IconX size={20} stroke={1.5} />
                    </button>
                </div>

                <div className="confirm-modal__body">
                    <p className="confirm-modal__text">
                        {formatSubscriptionTitle(subscription)} (истекла{' '}
                        {formatExpiryDate(subscription.expires_at)}) будет удалена из аккаунта.
                        Это действие нельзя отменить.
                    </p>

                    <ErrorMessage message={error} />

                    <div className="confirm-modal__actions">
                        <button type="button" className="btn btn--ghost" onClick={onClose}>
                            Отмена
                        </button>
                        <button
                            type="button"
                            className="btn btn--danger"
                            onClick={handleConfirm}
                            disabled={loading}
                        >
                            {loading ? 'Удаляем...' : 'Удалить'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
